export class GenAiTelemetryAttributeNames {
  static readonly operationName = "gen_ai.operation.name";
  static readonly requestModel = "gen_ai.request.model";
  static readonly usageInputTokens = "gen_ai.usage.input_tokens";
  static readonly usageOutputTokens = "gen_ai.usage.output_tokens";
  static readonly usageTotalTokens = "gen_ai.usage.total_tokens";
  static readonly usageCacheReadInputTokens = "gen_ai.usage.cache_read.input_tokens";
  static readonly usageCacheCreationInputTokens = "gen_ai.usage.cache_creation.input_tokens";
  static readonly usageReasoningTokens = "codemation.gen_ai.usage.reasoning_tokens";
}
